module.exports = __webpack_public_path__ + "img/yb6.218af462.jpg";